import React from 'react';
import CardMedia from '../../../../CardMedia';
import ArticleCardBase from '../../Base';

import './styles.scss';

const PortraitTwoImagesWithHeadline2 = ({ data, endCard }) => {
  const { backgroundColor, firstLetter, articleAsset1, articleAsset2, imageFit, paragraphC10 } =
    data;

  return (
    <ArticleCardBase variation="portrait" accentColor1={backgroundColor} endCard={endCard}>
      <section className="card-container portrait-two-images-with-headline-2">
        {articleAsset1.length ? (
          <div className="portrait-two-images-with-headline-2__asset-wrapper-1">
            <CardMedia
              url={articleAsset1[0].url}
              title={articleAsset1[0].title}
              mimeType={articleAsset1[0].mimeType}
              mediaContainerClasses="portrait-two-images-with-headline-2__media-container"
              imageFit={imageFit}
              cardImageSizes={[
                { actual: 136, intrinsic: 250 },
                { actual: 225, intrinsic: 450 }
              ]}
              loop
              isAutoplay
            />
          </div>
        ) : null}

        <div
          className="portrait-two-images-with-headline-2__paragraph"
          dangerouslySetInnerHTML={{ __html: paragraphC10 }}
        />
        <div
          className="portrait-two-images-with-headline-2__letter"
          dangerouslySetInnerHTML={{ __html: firstLetter }}
        />
        {articleAsset2.length ? (
          <div className="portrait-two-images-with-headline-2__asset-wrapper-2">
            <CardMedia
              url={articleAsset2[0].url}
              title={articleAsset2[0].title}
              mimeType={articleAsset2[0].mimeType}
              mediaContainerClasses="portrait-two-images-with-headline-2__media-container"
              imageFit={imageFit}
              cardImageSizes={[
                { actual: 239, intrinsic: 450 },
                { actual: 456, intrinsic: 780 }
              ]}
              loop
              isAutoplay
            />
          </div>
        ) : null}
      </section>
    </ArticleCardBase>
  );
};

export default PortraitTwoImagesWithHeadline2;
